module.exports = __webpack_public_path__ + "images/13.png";